import { render, staticRenderFns } from "./pro-plan.vue?vue&type=template&id=1ec80842&scoped=true&"
import script from "./pro-plan.vue?vue&type=script&lang=js&"
export * from "./pro-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec80842",
  null
  
)

export default component.exports